import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { QueryOptions, QueryResult, ProcessResult } from '../components/common-dto/query.dto';
import {
  ConferenceDto,
  ConferenceMetricsDto,
  ConnectionTimeSeriesDto,
  ConnectionCategoryDto,
  SessionDto,
  ConferenceLogDto,
  BusinessConnectionsLeaderboardDto,
  AttendeeConnectionsLeaderboardDto,
} from '../dto/conference.dto';

@Injectable({
  providedIn: 'root',
})
export class ConferenceService {
  constructor(
    private backend: BackendService,
    private http: HttpClient
  ) {}

  getConferences(queryParams: QueryOptions): Observable<QueryResult<ConferenceDto>> {
    return this.backend.getQuery<ConferenceDto>('conference', queryParams);
  }

  getConference(id: string): Observable<ConferenceDto> {
    return this.backend.get<ConferenceDto>(`conference/${id}`);
  }

  joinConference(conferenceId: string): Observable<ProcessResult> {
    return this.backend.post<ProcessResult>(`conference/${conferenceId}/join`, {});
  }

  leaveConference(conferenceId: string): Observable<ProcessResult> {
    return this.backend.post<ProcessResult>(`conference/${conferenceId}/leave`, {});
  }

  getConferenceMetrics(conferenceId: string): Observable<ConferenceMetricsDto> {
    return this.backend.get<ConferenceMetricsDto>(`conference/${conferenceId}/metrics`);
  }

  getConnectionsOverTime(conferenceId: string): Observable<ConnectionTimeSeriesDto[]> {
    return this.backend.get<ConnectionTimeSeriesDto[]>(`conference/${conferenceId}/connections-over-time`);
  }

  getConnectionsByCategory(conferenceId: string): Observable<ConnectionCategoryDto[]> {
    return this.backend.get<ConnectionCategoryDto[]>(`conference/${conferenceId}/connections-by-category`);
  }

  getSessions(conferenceId: string, queryParams: QueryOptions): Observable<QueryResult<SessionDto>> {
    return this.backend.getQuery<SessionDto>(`conference/${conferenceId}/sessions`, queryParams);
  }

  getConferenceLogs(conferenceId: string, queryParams: QueryOptions): Observable<QueryResult<ConferenceLogDto>> {
    return this.backend.getQuery<ConferenceLogDto>(`conference/${conferenceId}/logs`, queryParams);
  }

  getMostRecentLog(conferenceId: string): Observable<ConferenceLogDto | null> {
    return this.backend.get<ConferenceLogDto | null>(`conference/${conferenceId}/logs/most-recent`);
  }

  getBusinessConnectionsLeaderboard(conferenceId: string): Observable<BusinessConnectionsLeaderboardDto[]> {
    return this.backend.get<BusinessConnectionsLeaderboardDto[]>(`conference/${conferenceId}/connections/leaderboard/businesses`);
  }

  getAttendeeConnectionsLeaderboard(conferenceId: string): Observable<AttendeeConnectionsLeaderboardDto[]> {
    return this.backend.get<AttendeeConnectionsLeaderboardDto[]>(`conference/${conferenceId}/connections/leaderboard/attendees`);
  }

  createConference(conference: ConferenceDto): Observable<ProcessResult> {
    conference.createdAt = undefined;
    conference.updatedAt = undefined;
    return this.backend.post<ProcessResult>('conference', conference);
  }
}

